module.exports = __webpack_public_path__ + "static/media/sonder2.6d49a903.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/article/sonder2.jpg
// module id = 381
// module chunks = 0